import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicenseRoutingModule } from './license-routing.module';
import { SharedModule } from '@shared';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { PaymentsModule } from '../payments/payment.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_DATE_FORMATS, MY_DATE_ADAPTER } from './license-date-format';
import { InHomeCareComponent } from './in-home-care/in-home-care.component';
import { AdministratorApplicationComponent } from './in-home-care/administrator-application/administrator-application.component';
import { ManagementExperienceComponent } from './in-home-care/management-experience/management-experience.component';
import { ProfessionalExperienceComponent } from './in-home-care/professional-experience/professional-experience.component';
import { ReusableModule } from '../reusable/reusable.module';
import { InHomeCareChangeDialogComponent } from './in-home-care/in-home-care-change/in-home-care-change-dialog.component';
import { ManageInHomeCareChangesComponent } from './in-home-care/manage-in-home-care-changes/manage-in-home-care-changes.component';
import { ExportInHomeCareLicenseDialogComponent } from './in-home-care/dialog-export-in-home-care-license/dialog-export-in-home-care-license.component';
import { SubunitDetailsDialogComponent } from './in-home-care/dialog-subunit-details/dialog-subunit-details.component';
import { LicensedAgenciesComponent } from './in-home-care/licensed-agencies/licensed-agencies.component';
import { HemoTechComponent } from './hemo-tech/hemo-tech.component';
import { InHomeCareOwnerChangeDialogComponent } from './in-home-care/in-home-care-owner-change/in-home-care-owner-change.component';
import { HospitalComponent } from './hospital/hospital.component';
import { HospitalSnapshotComponent } from './hospital/hospital-snapshot.component';
import { HemoTechPublicListComponent } from './hemo-tech/hemo-tech-public-list/hemo-tech-public-list.component';
import { HemoTechLicenseExportComponent } from './hemo-tech/hemo-tech-license-export/hemo-tech-license-export.component';
import { HemoTechChangeComponent } from './hemo-tech/hemo-tech-change/hemo-tech-change.component';

const COMPONENTS = [
  InHomeCareComponent,
  AdministratorApplicationComponent,
  ManagementExperienceComponent,
  ProfessionalExperienceComponent,
  InHomeCareChangeDialogComponent,
  ManageInHomeCareChangesComponent,
  ExportInHomeCareLicenseDialogComponent,
  SubunitDetailsDialogComponent,
  LicensedAgenciesComponent,
  HemoTechComponent,
  InHomeCareOwnerChangeDialogComponent,
  HospitalComponent,
  HospitalSnapshotComponent,
  HemoTechPublicListComponent,
  HemoTechLicenseExportComponent,
  HemoTechChangeComponent,
]

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    NgxMaskDirective,
    NgxMaskPipe,
    CommonModule,
    SharedModule,
    ReusableModule,
    LicenseRoutingModule,
    PaymentsModule
  ],
  providers: [
    provideNgxMask(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    MY_DATE_FORMATS,
    MY_DATE_ADAPTER,
  ]
})
export class LicenseModule { }
